export const GLOBAL_TIMEZONE = 'America/Los_Angeles';
